webpackJsonp([72],{

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1381);


/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _ja = __webpack_require__(855);

var _ja2 = _interopRequireDefault(_ja);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('ja', _ja2.default);

/***/ })

},[1380]);


// WEBPACK FOOTER //
// app/datetime.ja-4e2c0122c9e9558faf48.js